import { SELF_SERVICE_STATS_REQUEST_TYPES } from 'constants/SelfServiceConstants';

export const generateInitialState = initialState =>
  Object.keys(SELF_SERVICE_STATS_REQUEST_TYPES).reduce((acc, value) => ({ ...acc, [value]: initialState }), {});
